import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import contentImage from "../../../../assets/contentImage.png";
import Buttons from "./Buttons";
import { PDFViewer } from "@react-pdf/renderer";
import PDFDocument from "./PDFDocument";
import "./psychometric.css";

function Content() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleTakeTestClick = () => {
    navigate("/pychometric/about"); // Navigate to About page
  };

  // const userDetail = {
  //   id: 184,
  //   name: "John Doe",
  //   email: "johnwderf@example.com",
  //   phone: "1234567890",
  //   alt_phone: "0987654321",
  //   pdf_link: null,
  // };

  // const data = {
  //   strengths: [],
  //   weaknesses: [],
  //   career_fields: [],
  // };

  return (
    <div className="psych-page">
      {/* Floating particles */}
      <div className="psych-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      {!location.pathname.includes("/thankyou") && (
        <div className="psych-hero">
          <div className="psych-hero-text">
            {/* AI Badge */}
            <div className="ai-badge" style={{ marginBottom: "1rem" }}>
              <span className="ai-dot"></span>
              AI-Powered Assessment
            </div>

            <h1>
              Discover Your Career Potential: <br />
              Take our Psychometric Tests Now!
            </h1>
            <p>
              Uncover your ideal career path &amp; Personality Trait with our
              AI-driven psychometric tests — smart, scientific, and personalized
              just for you.
            </p>
            <Link to="/psychometric/about " style={{ textDecoration: "none" }}>
              <Buttons text="Take the Test" />
            </Link>
          </div>

          <div className="psych-hero-image">
            <img
              src={contentImage}
              alt="Psychometric Test Illustration"
            />
          </div>
        </div>
      )}

      {location.pathname.includes("/thankyou") && (
        <div className="psych-thankyou">
          <div className="psych-thankyou-inner">
            <div className="ty-icon">✓</div>
            <h1>Thank You for Taking the Test!</h1>
            <p style={{ color: "var(--psych-text-muted)", marginBottom: "1.5rem", lineHeight: "1.7" }}>
              Your AI-generated career assessment report will be sent to your email shortly.
            </p>

            {/* Expert Counseling CTA */}
            <div className="psych-cta-card" style={{ maxWidth: "100%", textAlign: "left" }}>
              <div className="cta-icon">🎯</div>
              <h3>Want Deeper, Personalized Guidance?</h3>
              <p>
                This AI assessment provides a foundational overview of your strengths and career
                inclinations. For a <strong style={{ color: "#fff" }}>comprehensive, expert-led career counseling session</strong> tailored
                specifically to your goals, aspirations, and unique personality — our certified
                career counselors are here to help.
              </p>
              <div className="cta-highlight">
                <span>✦ 1-on-1 Expert Sessions &nbsp;·&nbsp; Personalized Roadmap &nbsp;·&nbsp; 5000+ Students Guided</span>
              </div>
              <p style={{ fontSize: "0.78rem", fontStyle: "italic" }}>
                "The AI test is just the beginning — let our experts unlock your full potential."
              </p>
              <div className="cta-contact">
                <a href="tel:+918108745275">📞 +91 8108 745 275</a>
                <a href="mailto:info@aaraconsultancy.com">✉ info@aaraconsultancy.com</a>
                <a href="https://aaraconsultancy.com/one-on-one-counseling/" target="_blank" rel="noopener noreferrer">
                  🌐 Book Your 1-on-1 Counseling →
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <PDFDocument data={data} userDetail={userDetail} />
      </PDFViewer> */}
    </div>
  );
}

export default Content;
